// extracted by mini-css-extract-plugin
export default {"wrapper":"TokenCard_wrapper__Rj9lQ","percent":"TokenCard_percent__lbKQv","description":"TokenCard_description__s-BsC"};